<template>
  <transition name="slide">
    <!-- Champions jackpot -->
    <div class="slide champions-jackpot-main">
      <div class="main-jackpot-wrap">
        <img src="https://cloud.aleacontrol.com/media/vSoccer/champions-jackpot-head.png" alt="" />
        <div class="ticket-info">
          <div class="amount">
            {{ format(jackpotAmount) }} <span>{{ currency.toUpperCase() }}</span>
          </div>
          <div class="ticket">
            <div class="ticket-id">
              {{ this.$t("ticket_no") }} <span>{{ partiallyMaskTicketId(ticketNo) }}</span>
            </div>
            <div class="location">
              {{ this.$t("ticket_location") }}
              <span>{{ ticketLocation }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import NumberFormat from '@/mixins/NumberFormat'
import LanguageHelper from '@/mixins/LanguageHelper'

export default {
  mixins: [NumberFormat, LanguageHelper],
  props: {
    ticketNo: {
      type: String,
      required: true
    },
    ticketLocation: {
      type: String,
      default: ''
    },
    jackpotAmount: {
      type: Number,
      default: 0
    },
    currency: {
      type: String,
      default: ''
    }
  },
  methods: {
    format: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    partiallyMaskTicketId: function (ticketId) {
      if (ticketId && ticketId.length > 4) {
        return '*'.repeat(ticketId.length - 4) + ticketId.slice(-4)
      }
    }
  }
}
</script>
